module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dasboard-container"
  }, [(_vm.loadingChannels) ? _c('div', [_c('loader', {
    attrs: {
      "message": "Fetching Social Channels",
      "shadow": "none"
    }
  })], 1) : (!_vm.socialChannels || !_vm.socialChannels.length) ? _c('div', [_c('content-placeholder', {
    attrs: {
      "count": 1,
      "text-only": true,
      "text-value": "You don't have any social channels. Please go to channels to add some."
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "row row-1"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('page-demographics-overview', {
    attrs: {
      "demographicData": _vm.demographicData,
      "isLoading": _vm.demographicsLoading,
      "facebookPages": _vm.facebookChannels,
      "selectedPage": _vm.selectedFacebookPage,
      "selectedDemographicType": _vm.selectedDemographic
    },
    on: {
      "onSelectedPageChange": _vm.handlePageChange,
      "onSelectedDemographicTypeChanged": _vm.handleDemographicTypeChanged
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('facebook-insights-overview', {
    staticClass: "insights",
    attrs: {
      "isLoading": _vm.insightsOverviewLoading,
      "overviewData": _vm.insightOverviewData,
      "facebookPages": _vm.facebookChannels,
      "selectedPage": _vm.selectedFacebookPage
    },
    on: {
      "onSelectedPageChange": _vm.handlePageChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('instagram-insights-overview', {
    staticClass: "insights",
    attrs: {
      "isLoading": _vm.instagramInsightsOverviewLoading,
      "overviewData": _vm.instagramInsightOverviewData,
      "instagramPages": _vm.instagramChannels,
      "selectedPage": _vm.selectedInstagramPage
    },
    on: {
      "onInstagramPeriodChanged": _vm.fetchInstagramInsightsOverviewData,
      "onSelectedPageChange": _vm.handleInstagramPageChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row-3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('post-overview', {
    attrs: {
      "isLoading": _vm.facebookPostInsightLoading,
      "facebookPages": _vm.facebookChannels,
      "postInsights": _vm.facebookPostInsightData,
      "selectedPage": _vm.selectedFacebookPage,
      "pages": _vm.postInsightPageSize
    },
    on: {
      "onSelectedPageChange": _vm.handlePageChange,
      "changePage": _vm.changePostInsightPage,
      "onChangeSerachTerm": _vm.changeSerachTerm
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h1', [_vm._v("Social Analytics")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e198fcb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/social/SocialAnalyticsDashboard.vue
// module id = 3302
// module chunks = 3